/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Handover_AnswerInputs */

const en_faq_handover_answer = /** @type {(inputs: Faq_Handover_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agreed working system, documentation and guidance for the people using it. We also agree ownership, access and an operating plan before launch.`)
};

const lv_faq_handover_answer = /** @type {(inputs: Faq_Handover_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saskaņoto strādājošo sistēmu, dokumentāciju un norādes cilvēkiem, kas to lieto. Pirms ieviešanas vienojamies arī par atbildību, piekļuvi un darbības plānu.`)
};

/**
* | output |
* | --- |
* | "The agreed working system, documentation and guidance for the people using it. We also agree ownership, access and an operating plan before launch." |
*
* @param {Faq_Handover_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_handover_answer = /** @type {((inputs?: Faq_Handover_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Handover_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_handover_answer(inputs)
	return en_faq_handover_answer(inputs)
});